import chroma from 'chroma-js'

export const colourStyles = {
  control: (styles: any) => ({ ...styles, backgroundColor: 'white' }),
  option: (styles: { [x: string]: any }, { data, isDisabled, isFocused, isSelected }: any) => {
    const color = chroma(data.color)
    return {
      ...styles,
      backgroundColor: isDisabled ? null : isSelected ? data.color : isFocused ? color.alpha(0.1).css() : null,
      color: isDisabled ? '#ccc' : 'black',
      cursor: isDisabled ? 'not-allowed' : 'default',

      ':active': {
        ...styles[':active'],
        backgroundColor: !isDisabled && (isSelected ? data.color : color.alpha(0.3).css()),
      },
    }
  },
  menuPortal: (base: any) => ({ ...base, zIndex: 9999 }),
  menu: (provided: any) => ({ ...provided, zIndex: '9999 !important' }),
  multiValue: (styles: any, { data }: any) => {
    const color = chroma(data.color)
    return {
      ...styles,
      backgroundColor: color.alpha(0.1).css(),
    }
  },
  multiValueLabel: (styles: any) => ({
    ...styles,
    color: 'black',
  }),
  multiValueRemove: (styles: any, { data }: any) => ({
    ...styles,
    color: 'black',
    ':hover': {
      backgroundColor: data.color,
      color: 'black',
    },
  }),
}

export const getSelected = (value: any, options: any, isMulti: boolean) => {
  if (!isMulti) {
    if (typeof value === 'number') return options.find((option: any) => option.value === value)
    return value
  }
  const result: any = []
  if (value && value[0] && value[0].name) {
    value.map((x: any) => {
      const selected = options.find((option: any) => option.label === x.name)
      selected && !result.find((x: any) => x.label === selected.label) && result.push(selected)
    })
    return result
  } else {
    return []
  }
}
